import * as partsSalesJapanActions from './partsSalesJapanReportActions';
const Actions = {
  ...partsSalesJapanActions,
};
export default Actions;
